<template>
	<div v-if="!!dataBinAssignment.DETAILS" class="class-page">
		<!-- Header -->
		<ClassPageHeader :details="details" :current-section="parseInt(sectionId)" :course="course" :menu="menu" :is-class-item-page="true" />

		<template v-if="!!response">
			<br />
			<div class="row" style="margin-left: 0; margin-right: 0;">
				<div class="col-xs-12 alert alert-info alert-success">
					{{ response }}
				</div>
			</div>
		</template>

		<div class="assignment-bin">
			<div class="display-table submission-page">
				<div class="display-container">
					<!-- Assignment header -->
					<div class="header color-status">
						<div :class="'pill float-left ' + dueSoon( dataBinAssignment.ASSIGNMENT_END_DATE )">
							{{ $t('MAIN_CONTENT.AssignmentBin.due', { date: dateFormat( dataBinAssignment.ASSIGNMENT_END_DATE ) } ) }}
						</div>
						<div class="score-pill float-right">
							{{$t('MAIN_CONTENT.commonContent.score')}} 
							<strong v-if="!!dataBinAssignment.DETAILS.MAX_POINTS">
								{{ $t( 'MAIN_CONTENT.AssignmentBin.gradeOverPoints', { grade: dataBinAssignment.DETAILS.GRADE_CODE, points: dataBinAssignment.DETAILS.MAX_POINTS } ) }}
							</strong>
							<strong v-else>{{ $t( 'MAIN_CONTENT.AssignmentBin.hyphen' ) }}</strong>
						</div>
					</div>
					<!-- Assignment sub-header -->
					<div class="sub-header">
						<div>
							<a><h2>{{ dataBinAssignment.ASSIGNMENT_NAME }}</h2></a>
							<div class="float-right">
								<a href="#" class="pointer" @click.prevent="goToSubmissions()">
									{{ $t('MAIN_CONTENT.AssignmentBin.mySubmissions') }} 
									<span class="pill pill-submissions">
										{{ dataBinAssignment.SUBMISSIONS.length }}
									</span>
								</a>
							</div>
							<div v-html="dataBinAssignment.ASSIGNMENT_DESC" class="description"></div>
							<div v-if="dataBinAssignment.ATTACHMENTS.length" class="attached" style="padding:10px;">
								<h3>
									{{ $t( 'MAIN_CONTENT.AssignmentBin.attachedFiles' ) }} <span class="badge badge-dark">{{ dataBinAssignment.ATTACHMENTS.length }}</span>
								</h3>
								<div v-for="( attachment, index ) in dataBinAssignment.ATTACHMENTS" :key="index" class="attached-file">
									<a :href="attachment.ATTACHMENT_URL" target="_blank">
										<i class="fas fa-file-word" aria-hidden="true"></i> 
										{{ $t( 'MAIN_CONTENT.AssignmentBin.bytesMessage', { name: attachment.REPORT_NAME, size: attachment.CONTENT_SIZE } ) }}
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- Shows add sumbission section if is not expired -->
				<div class="add-submission" v-if="role === 'student' && !hasReachedSubmissionLimit && (!isExpired( dataBinAssignment.ASSIGNMENT_END_DATE ) || dataBinAssignment.ALLOW_LATE_SUBMISSION === 'Y') && (dataBinAssignment.ALLOW_FILE_SUBMISSION === 'Y' || dataBinAssignment.ALLOW_TEXT_SUBMISSION === 'Y')">
					<h3>
						{{ $t('MAIN_CONTENT.Submission.addSubmission') }}
					</h3>
					<div class="display-container">
						<div class="new-submission">
							<!-- Text submission -->
							<div class="text-submission" v-if="dataBinAssignment.ALLOW_TEXT_SUBMISSION === 'Y'">
								<div class="title">
									<h4>
										{{ $t('MAIN_CONTENT.Submission.textSubmissionColon') }}
									</h4>
								</div>
								<div class="details">
									<ckeditor4 v-model="text"
														:config="editorConfig"
														:simpleImagesDialog="true"
														id="reply-message">
									</ckeditor4>
								</div>
							</div>
							<!-- Attachments submission -->
							<div class="attach-submission" v-if="dataBinAssignment.ALLOW_FILE_SUBMISSION === 'Y'">
								<div class="title">
									<h4>
										{{ $t('MAIN_CONTENT.AssignmentBin.attachedFilesColon') }}
									</h4>
								</div>
								<div class="details">
									<!-- Attachment buttons -->
									<div class="buttons">
										<h3 class="text-center" v-if="dataBinAssignment.NO_FILES_ALLOWED === 'O'">
											{{ $t('MAIN_CONTENT.Submission.oneFileUpload') }}
										</h3>
									</div>
									<div class="dropzone-area" v-if="loadedFilePickerData">
										<file-uploader
											ref="fileUpload"
											:nameHeader="$t( 'MAIN_CONTENT.commonContent.name' )"
											:sizeHeader="$t( 'MAIN_CONTENT.commonContent.size' )"
											:removeHeader="$t( 'MAIN_CONTENT.commonContent.remove' )"
											:dropSingleFile="$t( 'MAIN_CONTENT.commonContent.dropSingleFile' )"
											:dropMultipleFiles="$t( 'MAIN_CONTENT.commonContent.dropMultipleFiles' )"
											:selectSingleFile="$t( 'MAIN_CONTENT.commonContent.selectSingleFile' )"
											:selectMultipleFiles="$t( 'MAIN_CONTENT.commonContent.selectMultipleFiles' )"
											:attachFile="$t( 'MAIN_CONTENT.commonContent.attachFile' )"
											:attachFiles="$t( 'MAIN_CONTENT.commonContent.attachFiles' )"
											:files="files"
											:size="dataBinAssignment.MAX_SUBMISSION_SIZE"
											:multiple="dataBinAssignment.NO_FILES_ALLOWED === 'U'"
											:URL="externalFileData"
											:postAction="fileUploadToken"
											@updateFiles="updateValue"
											@saveGoogleFilesData="saveGoogleFileData(file=$event, multiple=dataBinAssignment.NO_FILES_ALLOWED === 'U')"
											@saveDropboxFilesData="saveDropboxFileData(file=$event, multiple=dataBinAssignment.NO_FILES_ALLOWED === 'U')"
											@saveOneDriveFilesData="saveOneDriveFileData(file=$event, multiple=dataBinAssignment.NO_FILES_ALLOWED === 'U')"
											v-if="showFileUploader"
										>
										</file-uploader>
									</div>
								</div>
							</div>
						</div>
						<!-- Submission actions -->
						<div class="submission-actions" >
							<div>
								<button @click="reset" class="btn btn-cancel"> 
									{{ $t('commonText.cancel') }}
								</button>
								<button class="btn btn-submit" @click="save" :disabled="!dirty || (files.length === 0 && text.length === 0)">
									{{ $t('MAIN_CONTENT.commonContent.submit') }}
								</button>
							</div>
						</div>
					</div>
				</div>
				<div v-else-if="hasReachedSubmissionLimit">
					<p class="text-danger text-center">{{ $t('MAIN_CONTENT.Submission.onlyOneSubmission') }}</p>
				</div>
				<!-- If the assignemnt is expired shows a message -->
				<div v-else>
					<p class="text-danger text-center">{{ $t('MAIN_CONTENT.Submission.assignmentBinClosed') }}</p>
				</div>
				<div class="feedback" v-if="!!dataBinAssignment.FEEDBACK.FEEDBACK_TEXT">
					<a @click="goToFeedback(assignment)" class="btn btn-feedback">{{ $t('MAIN_CONTENT.AssignmentBin.seeFeedback') }}</a>
				</div>
				<!-- Submission list -->
				<div class="my-submissions" id="assignment_bin_submissions">
					<h3>
						{{ $t('MAIN_CONTENT.AssignmentBin.mySubmissions') }}
					</h3>
					<div v-for="submission in dataBinAssignment.SUBMISSIONS" :key="submission.SUBMISSION_ID" class="display-container">
						<!-- Submission header -->
						<div class="header">
							<h4>
								{{ submission.CREATED_DATE }}
							</h4>
						</div>
						<!-- Submission attachments -->
						<div v-if="submission.ATTACHMENTS.length" class="attached">
							<p>{{ $t('MAIN_CONTENT.Submission.submittedFiles') }}</p>
							<div v-for="( attachment, i ) in submission.ATTACHMENTS" :key="i" class="attached-file">
								<a :href="attachment.ATTACHMENT_URL" target="_blank">
									<i :class="`fas ${ fileType( attachment.CONTENT_ID ) }`" aria-hidden="true">
									</i> {{ attachment.CONTENT_FILENAME }}
								</a>
							</div>
						</div>
						<!-- Submission text -->
						<div v-if="submission.TEXT_SUBMISSION !== ''" class="submission-text">
							<p>{{ $t('MAIN_CONTENT.Submission.textSubmission') }}</p>
							<div class="text-box">
								<p v-html="submission.TEXT_SUBMISSION"></p>
							</div>
						</div>
					</div>
				</div>
				<!-- Return back button -->
				<div class="back-link">
					<a style="cursor:pointer" @click="reset">
						<i class="fas fa-caret-left" aria-hidden="true"></i>{{ $t('MAIN_CONTENT.commonContent.goBack') }}
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import moment from "moment";
	import { mapActions, mapState, mapGetters } from "vuex";
	import ClassPageHeader from "../Header.vue";
	import ClassPageFooter from "../Footer.vue";

	import { buildFileData } from '../glossary/buildFileData';

	import ClassPageHomeResource from '../../../api/ClassPageHome';
	import ClassPageDetailsResource from '../../../api/ClassPageDetails';
	import ClassPageAssignmentBinResource from '../../../api/ClassPageAssignmentBin';
	import ClassPageAssignmentBinAssignmentResource from '../../../api/ClassPageAssignmentBinAssignment';
	import ClassPageAssignmentBinSubmissionResource from '../../../api/ClassPageAssignmentBinSubmission';
	import ClassPageMenuResource from '../../../api/ClassPageMenu';
	import CoursesResource from '../../../api/Courses';
	import ExternalFilePicker from '../../../api/ExternalFilePicker';
	import ExternalFilesPost from '../../../api/ExternalFilesPost';
	import FileUploadTokenResource from '../../../api/FileUploadToken';

	import FileUploader from 'COMMONS/shared/FileUploader.vue';
	import ckeditor4 from '../../ckeditor4.vue';

	import editorConfigObj from '../../shared/editorConfigObj';

	export default {
		name: "Submission",
		data() {
			return {
				showFileUploader: true,
				fileUploadToken: '',
				dataBinAssignment: [],
				menu: [],
				details: {},
				dirty: false,
				course: {},
				courseContent: {},
				loadedFilePickerData: false,
				externalFileData: {
					API_ORIGIN_URL:							'',
					DISTRICT_ID:								'',
					DROPBOX_API_CLIENT_ID:			'',
					DROPBOX_API_CLIENT_SECRET:	'',
					GOOGLE_API_APP_ID:					'',
					GOOGLE_API_CLIENT_ID:				'',
					GOOGLE_API_CLIENT_SECRET:		'',
					ONEDRIVE_API_CLIENT_ID:			'',
					ONEDRIVE_API_CLIENT_SECRET:	''
				},
				editorConfig: editorConfigObj,
				text:							'',
				message:					'',
				files:						[],
				assignment:				{},
				response:					'',
				oauthToken:				null,
				pickerApiLoaded:	false,
				appId:						"1012757059728",
				clientId:					"1012757059728-t729asauc8sij0h49470do16vhvf3v81.apps.googleusercontent.com",
				developerKey:			"AIzaSyD0heYF6QV5WnhtyVZ25_CI53tuGIZekXQ",
				scope:						[
					"https://www.googleapis.com/auth/drive.file", "https://www.googleapis.com/auth/drive.metadata"
				]
			}
		},
		components: {
			ClassPageHeader,
			ClassPageFooter,
			ckeditor4,
			FileUploader
		},
		computed: {
			...mapGetters([ 'selectedStudent', 'accessToken', 'role' ]),
			hasReachedSubmissionLimit() {
				return this.dataBinAssignment.SUBMISSION_RESTRAINT_TYPE === 'O' && this.dataBinAssignment.SUBMISSIONS.length >= 1;
			},
			assignmentId() {
				return this.$route.params.assignmentId ? this.$route.params.assignmentId : 0;
			},
			sectionId() {
				return this.$route.params.folderId ? this.$route.params.folderId : 0;
			},
			courseSectionGuid() {
				return this.$route.params.courseSectionGUID;
			},
			submissionUploadUrl() {
				return `/PortalAPI/index.cfm/api/v1/class-pages/${this.courseSectionGuid}/files?student_rid=${this.selectedStudent.STUDENT_RID}`;
			},
			assignmentBinType() {
				let type = '';
				if( this.$route.name === 'ClassPageAssignmentBinSubmission' ) {
					type = 'course';
				} else if( this.$route.name === 'ClassPageSectionAssignmentBinSubmission' ) {
					type = 'course';
				} else if ( this.$route.name === 'ClassPageGroupAssignmentBinSubmission' ) {
					type = 'group';
				} else if ( this.$route.name === 'ClassPageStudentAssignmentBinSubmission' ) {
					type = 'student';
				}

				return type;
			},
			assignmentBinRouteName() {
				let type = '';
				if( this.$route.name === 'ClassPageAssignmentBinSubmission' ) {
					type = 'ClassPageAssignmentBin';
				} else if( this.$route.name === 'ClassPageSectionAssignmentBinSubmission' ) {
					type = 'ClassPageSectionAssignmentBin';
				} else if ( this.$route.name === 'ClassPageGroupAssignmentBinSubmission' ) {
					type = 'ClassPageGroupAssignmentBin';
				} else if ( this.$route.name === 'ClassPageStudentAssignmentBinSubmission' ) {
					type = 'ClassPageStudentAssignmentBin';
				}

				return type;
			},
			assignmentBinFeedbackRouteName() {
				let type = '';
				if( this.$route.name === 'ClassPageAssignmentBinSubmission' ) {
					type = 'ClassPageAssignmentBinFeedback';
				} else if( this.$route.name === 'ClassPageSectionAssignmentBinSubmission' ) {
					type = 'ClassPageSectionAssignmentBinFeedback';
				} else if ( this.$route.name === 'ClassPageGroupAssignmentBinSubmission' ) {
					type = 'ClassPageGroupAssignmentBinFeedback';
				} else if ( this.$route.name === 'ClassPageStudentAssignmentBinSubmission' ) {
					type = 'ClassPageStudentAssignmentBinFeedback';
				}

				return type;
			}
		},
		watch: {
			text(newText, oldText) {
				if(oldText.length === 0 && newText.length > 0) {
					this.dirty = true;
					this.response = '';
				}
			},
		},
		methods: {
			goToSubmissions() {
				let position = $('#assignment_bin_submissions').position().top;
				$('html').scrollTop(position);
			},
			addFile(e) {
				let files = e.target.files || e.dataTransfer.files;

				if (!files.length)
					return;
				this.createImage(files[0]);
				this.dirty = true;
				this.response = '';
			},
			createImage(file) {
				let image = new Image();
				let reader = new FileReader();
				let vm = this;

				reader.onload = (e) => {
					vm.image = e.target.result;
				};
				reader.readAsDataURL(file);
				this.dirty = true;
				this.response = '';
			},
			updateValue(files) {
				this.files = files;
				this.dirty = true;
				this.response = '';
			},
			removeFile(index) {
				this.files.splice(index, 1);
				this.dirty = true;
				this.response = '';
			},
			appendFile(evt, fieldId) {
				const responseData = JSON.parse(evt.xhr.responseText);
				if( typeof responseData === 'object' ){
					this.files.push(responseData.data);
					this.dirty = true;
					this.response = '';
				}
			},
			goToFeedback() {
				let name = '';
				let params = this.$route.params;
				params.assignmentId = this.assignmentId;
				
				this.$router.push({ 
					name: this.assignmentBinFeedbackRouteName, 
					params: params,
				});
			},
			fetchFileUploadToken() {
				const FileUploadToken = new FileUploadTokenResource({
					routeParams: {
						courseSectionGuid: this.$route.params.courseSectionGUID,
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
					},
				});

				FileUploadToken.get().then(() => {
					this.fileUploadToken = FileUploadToken.getResponseData();
				});
			},
			fetchAssignmentBinAssignment() {
				const Assignment = new ClassPageAssignmentBinAssignmentResource({
					routeParams: {
						courseSectionGuid: this.$route.params.courseSectionGUID,
						assignmentBinId: this.$route.params.assignmentBinId,
						assignmentId: this.$route.params.assignmentId,
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
					},
					type: this.assignmentBinType,
				});

				Assignment.get().then(() => {
					this.dataBinAssignment = Assignment.getResponseData();
				});
			},
			fetchAssignmentBin() {
				const AssignmentBin = new ClassPageAssignmentBinResource({
					routeParams: {
						courseSectionGuid: this.$route.params.courseSectionGUID,
						assignmentBinId: this.$route.params.assignmentBinId,
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
					},
					type: this.assignmentBinType,
				});

				AssignmentBin.get().then(() => {
					this.dataBinAssignment = AssignmentBin.getResponseData();
				});
			},
			fetchMenu() {
				const ClassPageMenu = new ClassPageMenuResource({
					routeParams: {
						courseSectionGuid: this.$route.params.courseSectionGUID,
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
					},
				});

				ClassPageMenu.get().then(()=>{
					this.menu = ClassPageMenu.getResponseData();
				});
			},
			fetchDetails() {
				const ClassPageDetails = new ClassPageDetailsResource({
					routeParams: {
						courseSectionGuid: this.$route.params.courseSectionGUID,
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
					},
				});

				ClassPageDetails.get().then(()=>{
					this.details = ClassPageDetails.getResponseData();
				});
			},
			fetchCourse() {
				const Course = new CoursesResource({
					routeParams: {
						courseSectionGuid: this.$route.params.courseSectionGUID,
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
					},
				});

				Course.get().then(()=>{
					this.course = Course.getResponseData();
				});
			},
			fetchClassHome(){
				const ClassPageHome = new ClassPageHomeResource({
					routeParams: {
						courseSectionGuid: this.$route.params.courseSectionGUID,
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
					},
				});

				ClassPageHome.get().then(()=>{
					this.courseContent = ClassPageHome.getResponseData().COURSE_CONTENT;
				});
			},
			/**
				* Format the date
				* @param { String } date
				* @returns { String }
			*/
			dateFormat: function ( date ) {
				if( date === '' ) {
					return '';
				}

				return moment( date ).format( "MM/DD/YYYY" );
			},
			/**
				* Due soon class name
				* @param { String } date
				* @returns { String }
			*/
			dueSoon( endDate ) {
				let today = moment();
				let end = moment( endDate );
				let future = moment().add( 3, "days" );
				
				if ( end < today )
						return "due-danger";

				else if ( today < end && end < future )
						return "due-warning";

				return "due-info";
			},
			/**
				* Verifies if the assignment is not expired
				* @param { String } date
				* @returns { Boolean }
			*/
			isExpired( endDate ) {
				let today  = moment();
				let end    = moment( endDate );

				return end < today;
			},
			/**
				* Shows every file and validates total size
				* @param { Integer } index of the array of files
			*/
			preview( event, index ) {
				// Is uploaded
				if ( event !== undefined && event.target !== undefined ) {
					let totalSize = 0;

					for ( let i = 0; i < event.target.files.length; i++ ) {
						totalSize += event.target.files[ i ].size;
					}

					if( totalSize > this.dataBinAssignment.MAX_SUBMISSION_SIZE ) {
						alert( "Size too high, maximum " + ( ( this.dataBinAssignment.MAX_SUBMISSION_SIZE / 1024 ) / 1024 ) + "MB" ); return;
					}

					this.files = Array.from( event.target.files );
				} else {
					// If is deleted a file recreate the array skipping a file clicked
					let newArray = new DataTransfer();

					for ( let i = 0; i < this.files.length; i++ ) {
						// Don't attach the clicked element
						if( index !== undefined && index === i ) {
							continue;
						}

						newArray.items.add( this.files[ i ] );
					}

					this.files = Array.from( newArray.files );
				}
			},
			/**
				* Determines the icon to use per file
				* @param { String } mime
				* @returns { String }
			*/
			fileType( mime ) {
				if( mime.includes( "word" ) )
						return "fa-file-word word-file";

				else if( mime.includes( "powerpoint" ) )
						return "fa-file-powerpoint ppt-file";

				else if( mime.includes( "pdf" ) )
						return "fa-file-pdf pdf-file";

				return "fa-file default-file";
			},
			save() {
				let files = [];

				if( !!this.$refs.fileUpload ){
					for(let i in this.$refs.fileUpload.files) {
						files.push(this.$refs.fileUpload.files[i].response.data);
						if( this.dataBinAssignment.NO_FILES_ALLOWED === 'O' ){
							break;
						}
					}
				}

				const Submission = new ClassPageAssignmentBinSubmissionResource({
					routeParams: {
						courseSectionGuid: this.$route.params.courseSectionGUID,
						assignmentBinId: this.$route.params.assignmentBinId,
						assignmentId: this.$route.params.assignmentId,
					},
					data: {
						text_submission: this.text,
						files: files,
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
					},
					type: this.assignmentBinType,
				});

				Submission.post().then(() => {
					if(!Submission.getResponseData().error) {
						this.files = [];
						this.text = '';
						this.$set(this, 'dirty', false);
						this.$set(this, 'response', Submission.getResponseData());
						window.scrollTo(0, 0);
						this.fetchAssignmentBinAssignment();
					}
				});
			},
			/** Reset the submission */
			reset() {
				this.showFileUploader = false;
				this.$router.go(-1);
			},
			getExternalData() {
				const self = this;

				const external = new ExternalFilePicker({
					query: {
						student_rid: self.selectedStudent.STUDENT_RID
					}
				});

				external.get().then(response => {
					self.$set(self, 'externalFileData', external.getResponseData());
					self.loadedFilePickerData = true;
				});
			},
			saveGoogleFileData(file, multiple=true) {
				const self = this;

				const external = new ExternalFilesPost({
					query: {
						student_rid: self.selectedStudent.STUDENT_RID,
						source: 'googleDrive',
						fielId: file.id
					},
					routeParams: {
						course_section_guid: self.$route.params.courseSectionGUID
					},
					data: {
						file_id: file.id,
						authorization: 'Bearer ' + file.authToken,
						file_name: file.name,
						file_mime: file.mimeType,
						web_content_link: file.webContentLink,
						web_view_link: file.webViewLink
					}
				});

				external.post().then(response => {
					let data = external.getResponseData();
					let dataObj = buildFileData(
						self.$route.params.courseSectionGUID,
						self.selectedStudent.STUDENT_RID,
						self.accessToken,
						self.$store.state.CLIENT_ID,
						data
					);

					let hasFile = false;

					for(let f in self.files) {
						let file = self.files[f];

						if(file.response.data.HASHA === data.HASHA && file.response.data.HASHB === data.HASHB) {
							hasFile = true;
							break;
						}
					}

					if(!hasFile && dataObj.response.data.HASHA && dataObj.response.data.HASHB) {
						if( multiple ){
							self.files.push( dataObj );
						} else {
							self.files.pop();
							self.files.push( dataObj );
						}
						self.dirty = true;
					}
				});
			},
			saveDropboxFileData(file, multiple=true) {
				const self = this;

				const external = new ExternalFilesPost({
					query: {
						student_rid: self.selectedStudent.STUDENT_RID,
						source: 'dropbox',
						fielId: file.id
					},
					routeParams: {
						course_section_guid: self.$route.params.courseSectionGUID
					},
					data: JSON.stringify({
						authorization: file.authToken,
						file_name: file.name,
						web_content_link: file.link
					})
				});

				external.post().then(response => {
					let data = external.getResponseData();
					let dataObj = buildFileData(
						self.$route.params.courseSectionGUID,
						self.selectedStudent.STUDENT_RID,
						self.accessToken,
						self.$store.state.CLIENT_ID,
						data
					);

					let hasFile = false;

					for(let f in self.files) {
						let file = self.files[f];

						if(file.response.data.HASHA === data.HASHA && file.response.data.HASHB === data.HASHB) {
							hasFile = true;
							break;
						}
					}

					if(!hasFile && dataObj.response.data.HASHA && dataObj.response.data.HASHB) {
						if( multiple ){
							self.files.push( dataObj );
						} else {
							self.files.pop();
							self.files.push( dataObj );
						}
						self.dirty = true;
					}
				});
			},
			saveOneDriveFileData(file, multiple=true) {
				const self = this;

				const external = new ExternalFilesPost({
					query: {
						student_rid: self.selectedStudent.STUDENT_RID,
						source: 'oneDrive',
						fielId: file.id
					},
					routeParams: {
						course_section_guid: self.$route.params.courseSectionGUID
					},
					data: JSON.stringify({
						file_name: file.name,
						web_content_link: file['@content.downloadUrl']
					})
				});

				external.post().then(response => {
					let data = external.getResponseData();

					let dataObj = buildFileData(
						self.$route.params.courseSectionGUID,
						self.selectedStudent.STUDENT_RID,
						self.accessToken,
						self.$store.state.CLIENT_ID,
						data
					);

					let hasFile = false;

					for(let f in self.files) {
						let file = self.files[f];

						if(file.response.data.HASHA === data.HASHA && file.response.data.HASHB === data.HASHB) {
							hasFile = true;
							break;
						}
					}

					if(!hasFile && dataObj.response.data.HASHA && dataObj.response.data.HASHB) {
						if( multiple ){
							self.files.push( dataObj );
						} else {
							self.files.pop();
							self.files.push( dataObj );
						}
						self.dirty = true;
					}
				});
			},
			confirmResponse(response) {
			}
		},
		created() {
			this.$store.commit('setTitleIcon', 'file-upload');
			this.$store.commit('setTitle', 'MAIN_CONTENT.Submission.assignmentBin');
			this.$store.commit('setUseHeader', true);
			
			this.fetchMenu();
			this.fetchDetails();
			this.fetchCourse();
			this.fetchClassHome();
			this.getExternalData();
			this.fetchFileUploadToken();
			this.fetchAssignmentBinAssignment();
		},
		beforeRouteLeave(to, from, next) {
			// called when the route that renders this component has changed,
			// but this component is reused in the new route.
			// For example, for a route with dynamic params `/foo/:id`, when we
			// navigate between `/foo/1` and `/foo/2`, the same `Foo` component instance
			// will be reused, and this hook will be called when that happens.
			// has access to `this` component instance.
			const self = this;

			if( self.dirty ) {
				self.message = self.$t('MAIN_CONTENT.Submission.dirtyPageAssignmentMessage');

				let dialogPromise = self.$dialog.confirm(self.message);

				dialogPromise.then(function(dialog) {
					console.log('then');
					next();
				}).catch(function(){
					console.log('catch');
					self.$nextTick(function() {
						self.showFileUploader = true;
						self.$router.go(1);
					});
				});
			} else {
				next();
			}
			
		}
	};
</script>
